<template>
  <el-tabs
    v-model="activeName"
    style="width: 96%;
    margin: 0 auto;
    margin-top: 23px;"
    @tab-click="handleClick"
  >
    <el-tab-pane label="订单统计" name="second"><OrderStatistics v-if="activeName === 'second'" /></el-tab-pane>
    <el-tab-pane label="粉丝统计" name="first"><AnalysisData v-if="activeName === 'first'" /></el-tab-pane>
  </el-tabs>
</template>

<script>
import AnalysisData from './components/analysisData.vue'
import OrderStatistics from './components/orderStatistics.vue'
export default {
  components: {
    AnalysisData,
    OrderStatistics
  },
  data() {
    return {
      activeName: 'second'
    }
  },
  methods: {
    handleClick(item) {
      // console.log(item)
    }
  }
}
</script>

<style scoped lang="less">

</style>
